
import React, { Component } from 'react';
import { auth } from '../services/firebase';
import { db } from '../services/firebase';

export default class NewChatBtn extends Component {
	constructor() {
		super();
        this.state = {
			user: auth().currentUser,
            error: null,
        };
		this.requestNewChat = this.requestNewChat.bind(this)
	}

    async requestNewChat() {
        let chatRequestRef = db.ref('chat-requests').child("mentalhealth").child(this.state.user.uid)

        await chatRequestRef.get().then((snapshot) => {
            // Create a new request if not existing
            if (snapshot.exists() === false) {
                let uid = this.state.user.uid

                let newChat = db.ref('chats').push({
                    chatType: "MentalHealth",
                    members: {[uid]: true},
                    sentDate: Math.floor(Date.now() / 1000),
                })

                chatRequestRef.set({
                    assignedTo: "",
                    created: Math.floor(Date.now() / 1000),
                    chatId: newChat.key,
                    chatType: "MentalHealth",
                    status: "pending",
                    userId: uid,
                })
            } else {
                // Renew requests that were canceled or completed
                if (snapshot.val()["status"] !== "pending") {
                    chatRequestRef.update({
                        created: Math.floor(Date.now() / 1000),
                        status: "pending"
                    });
                // Update request timestamp for existing requests
                } else {
                    chatRequestRef.update({
                        created: Math.floor(Date.now() / 1000),
                    });
                }
            }
        });
    }

    render() {
        return (
            <button type='button' onClick={this.requestNewChat} >
                +
            </button>
        );
    }
}
